let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("6SkE8")]).then(() => parcelRequire('gHrFG'));